module.exports = __webpack_public_path__ + "static/media/casas-ara.aa9cfb28.jpg";